import { render, staticRenderFns } from "./shoporderdetail.vue?vue&type=template&id=02174948&scoped=true&"
import script from "./shoporderdetail.vue?vue&type=script&lang=js&"
export * from "./shoporderdetail.vue?vue&type=script&lang=js&"
import style0 from "./shoporderdetail.vue?vue&type=style&index=0&id=02174948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02174948",
  null
  
)

export default component.exports